module.exports = __webpack_public_path__ + "static/assets/cd6fe83816533a88ce1685af6d5a183f.png";